// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Responsive Styles */

/* Prevent horizontal overflow. Only on html, not body: having overflow-x:hidden on both
   is a known trigger for breaking \`position: sticky\` on descendants (two nested ancestors
   with non-visible overflow confuses the sticky containing-block calculation), and html
   alone is already the actual scrolling element here, so it's sufficient on its own. */
html {
  overflow-x: hidden;
  max-width: 100vw;
}
body {
  max-width: 100vw;
}

/* Mobile breakpoint: 768px and below */
@media (max-width: 768px) {
  /* Header adjustments */
  .App-header {
    padding: 0.75rem 1rem;
  }

  .header-main-row {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }

  .header-left {
    flex: 1 1;
  }

  .header-left h1 {
    font-size: 1.1rem;
    margin: 0;
  }

  .header-left p {
    font-size: 0.75rem;
    margin: 0.25rem 0 0 0;
  }

  .header-nav-section {
    display: none !important;
  }

  .header-right {
    display: none !important;
  }

  /* Sub navigation */
  .sub-nav-container {
    padding: 0.5rem;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .sub-nav .submenu-item {
    padding: 8px 12px;
    font-size: 0.8rem;
    flex: 1 1;
    min-width: calc(50% - 0.25rem);
  }

  /* Main content */
  .App-main {
    padding: 0.25rem;
    max-width: 100%;
    overflow-x: hidden;
  }

  /* Center align everything */
  .App-main > * {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  /* Remove extra margins and padding on mobile */
  .equity-container > * {
    margin-bottom: 0.5rem;
  }

  /* Equity page */
  .equity-container {
    padding: 0.25rem;
  }

  .equity-header {
    margin-bottom: 0.5rem;
  }

  .equity-header h2 {
    font-size: 1.25rem;
    text-align: center;
    margin: 0.5rem 0;
  }

  .equity-controls {
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    padding: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .equity-table-controls {
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    margin-bottom: 0.5rem;
    padding: 0;
  }

  /* Simplify equity table on mobile - only show Date, Total, Difference */
  /* Hide: Cash, Stocks, Options, Stocks Diff, Options Diff */
  .equity-table th:nth-child(2),
  .equity-table td:nth-child(2),
  .equity-table th:nth-child(3),
  .equity-table td:nth-child(3),
  .equity-table th:nth-child(4),
  .equity-table td:nth-child(4),
  .equity-table th:nth-child(5),
  .equity-table td:nth-child(5),
  .equity-table th:nth-child(6),
  .equity-table td:nth-child(6) {
    display: none !important;
  }

  .equity-table-container {
    padding: 0;
    margin: 0;
    width: 100%;
    overflow: visible;
  }

  .equity-table {
    font-size: 0.75rem;
    width: 100%;
    margin: 0;
    border-collapse: collapse;
    table-layout: fixed;
  }

  .equity-table th,
  .equity-table td {
    padding: 4px 2px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* Date column - 30% width */
  .equity-table th:first-child,
  .equity-table td:first-child {
    text-align: left;
    width: 30%;
    padding-left: 4px;
  }

  /* Total column - 35% width */
  .equity-table th:nth-child(7),
  .equity-table td:nth-child(7) {
    text-align: center;
    width: 35%;
  }

  /* Difference column - 35% width */
  .equity-table th:last-child,
  .equity-table td:last-child {
    text-align: right;
    width: 35%;
    padding-right: 4px;
  }

  /* Remove extra spacing */
  .equity-table thead th {
    padding: 6px 2px;
    font-size: 0.7rem;
  }

  .equity-table tbody td {
    padding: 4px 2px;
    font-size: 0.75rem;
  }

  /* Goals Display */
  .goals-display-widget {
    padding: 1rem;
  }

  .goals-header h3 {
    font-size: 1.25rem;
    text-align: center;
  }

  .goals-cards {
    flex-direction: column;
    gap: 1rem;
  }

  .goal-card {
    max-width: 100%;
    min-width: 100%;
    margin: 0 auto;
  }

  .year-equity-overview {
    flex-direction: column;
    gap: 10px;
    padding: 15px;
    text-align: center;
  }

  .equity-arrow {
    transform: rotate(90deg);
  }

  .year-progress-info {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  /* Hide year chart on mobile for simplicity */
  .year-progress-chart {
    display: none;
  }

  /* Open Positions - Only override for mobile, keep Equity styling for desktop */
  .open-positions-header h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .open-positions-header {
    text-align: center;
  }

  /* Hide description column on mobile - using class selector */
  .description-cell {
    display: none !important;
  }

  /* Hide description header - target th that contains "Description" text */
  .open-positions-table th.sortable-header {
    position: relative;
  }

  /* Hide description header by targeting the specific column */
  /* Note: This assumes description is after Symbol column - adjust if needed */
  .open-positions-table thead tr th:nth-child(3),
  .open-positions-table tbody tr td:nth-child(3) {
    display: none !important;
  }

  /* Trades table */
  .trades-table {
    font-size: 0.8rem;
  }

  .trades-table th,
  .trades-table td {
    padding: 6px 4px;
  }

  /* PMCC - Show only conclusions/summary */
  .pmcc-list-item {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .pmcc-detail-section {
    margin-bottom: 1rem;
  }

  /* Hide detailed PMCC tables on mobile, show only summary */
  .leaps-details-table,
  .covered-calls-details-table {
    display: none;
  }

  .summary-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .summary-stat {
    padding: 0.75rem;
    background: #f8f9fa;
    border-radius: 4px;
  }

  /* Tables - make scrollable */
  .equity-table-container,
  .open-positions-table-container,
  .trades-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Home page */
  .home-stats {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stat-card {
    padding: 1rem;
    text-align: center;
  }

  /* Hide complex charts and graphs on mobile */
  .home-charts,
  .home-graphs {
    display: none;
  }

  /* Login page */
  .login-container {
    padding: 1rem;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login-form {
    padding: 1.5rem;
    width: 100%;
    max-width: 100%;
  }

  /* Trades - simplify on mobile */
  .trades-header h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .trades-controls {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  /* Hide complex trade views on mobile */
  .trades-pnl-view,
  .trades-grouped-view {
    display: none;
  }

  /* Make all tables horizontally scrollable */
  table {
    min-width: 600px;
  }

  .table-container,
  .equity-table-container,
  .open-positions-table-container,
  .trades-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }

  /* Goals history table */
  .goals-history-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  /* Responsive text sizes */
  h1, h2, h3, h4 {
    word-wrap: break-word;
  }

  /* Better spacing for mobile */
  .App-main > * {
    margin-bottom: 1rem;
  }
}

  /* Very small screens (phones in portrait) */
@media (max-width: 480px) {
  .App-header {
    padding: 0.5rem 0.75rem;
  }

  .header-left h1 {
    font-size: 1rem;
  }

  .equity-header h2,
  .open-positions-header h2 {
    font-size: 1.1rem;
    margin: 0.25rem 0;
  }

  .equity-container {
    padding: 0.15rem;
  }

  .equity-table {
    font-size: 0.7rem;
  }

  .equity-table th,
  .equity-table td {
    padding: 3px 1px;
  }

  .equity-table thead th {
    padding: 5px 1px;
    font-size: 0.65rem;
  }

  .equity-table tbody td {
    padding: 3px 1px;
    font-size: 0.7rem;
  }

  .trades-table {
    font-size: 0.75rem;
  }

  .trades-table th,
  .trades-table td {
    padding: 4px 2px;
  }

  .goal-card {
    padding: 8px;
  }

  .year-progress-chart {
    margin-top: 20px;
  }

  .year-progress-chart h4 {
    font-size: 1rem;
  }
}

`, "",{"version":3,"sources":["webpack://./src/mobile.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;;;uFAGuF;AACvF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,SAAO;IACP,8BAA8B;EAChC;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,+CAA+C;EAC/C;IACE,qBAAqB;EACvB;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;EACZ;;EAEA,wEAAwE;EACxE,2DAA2D;EAC3D;;;;;;;;;;IAUE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,SAAS;IACT,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,4BAA4B;EAC5B;;IAEE,gBAAgB;IAChB,UAAU;IACV,iBAAiB;EACnB;;EAEA,6BAA6B;EAC7B;;IAEE,kBAAkB;IAClB,UAAU;EACZ;;EAEA,kCAAkC;EAClC;;IAEE,iBAAiB;IACjB,UAAU;IACV,kBAAkB;EACpB;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA,6CAA6C;EAC7C;IACE,aAAa;EACf;;EAEA,+EAA+E;EAC/E;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,6DAA6D;EAC7D;IACE,wBAAwB;EAC1B;;EAEA,yEAAyE;EACzE;IACE,kBAAkB;EACpB;;EAEA,6DAA6D;EAC7D,6EAA6E;EAC7E;;IAEE,wBAAwB;EAC1B;;EAEA,iBAAiB;EACjB;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,yCAAyC;EACzC;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,2DAA2D;EAC3D;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA,6BAA6B;EAC7B;;;IAGE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,cAAc;EACd;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;;IAEE,aAAa;EACf;;EAEA,eAAe;EACf;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA,gCAAgC;EAChC;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA,uCAAuC;EACvC;;IAEE,aAAa;EACf;;EAEA,4CAA4C;EAC5C;IACE,gBAAgB;EAClB;;EAEA;;;;IAIE,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;EACb;;EAEA,wBAAwB;EACxB;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA,0BAA0B;EAC1B;IACE,qBAAqB;EACvB;;EAEA,8BAA8B;EAC9B;IACE,mBAAmB;EACrB;AACF;;EAEE,4CAA4C;AAC9C;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Mobile Responsive Styles */\n\n/* Prevent horizontal overflow. Only on html, not body: having overflow-x:hidden on both\n   is a known trigger for breaking `position: sticky` on descendants (two nested ancestors\n   with non-visible overflow confuses the sticky containing-block calculation), and html\n   alone is already the actual scrolling element here, so it's sufficient on its own. */\nhtml {\n  overflow-x: hidden;\n  max-width: 100vw;\n}\nbody {\n  max-width: 100vw;\n}\n\n/* Mobile breakpoint: 768px and below */\n@media (max-width: 768px) {\n  /* Header adjustments */\n  .App-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .header-main-row {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n\n  .header-left {\n    flex: 1;\n  }\n\n  .header-left h1 {\n    font-size: 1.1rem;\n    margin: 0;\n  }\n\n  .header-left p {\n    font-size: 0.75rem;\n    margin: 0.25rem 0 0 0;\n  }\n\n  .header-nav-section {\n    display: none !important;\n  }\n\n  .header-right {\n    display: none !important;\n  }\n\n  /* Sub navigation */\n  .sub-nav-container {\n    padding: 0.5rem;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .sub-nav .submenu-item {\n    padding: 8px 12px;\n    font-size: 0.8rem;\n    flex: 1;\n    min-width: calc(50% - 0.25rem);\n  }\n\n  /* Main content */\n  .App-main {\n    padding: 0.25rem;\n    max-width: 100%;\n    overflow-x: hidden;\n  }\n\n  /* Center align everything */\n  .App-main > * {\n    max-width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  /* Remove extra margins and padding on mobile */\n  .equity-container > * {\n    margin-bottom: 0.5rem;\n  }\n\n  /* Equity page */\n  .equity-container {\n    padding: 0.25rem;\n  }\n\n  .equity-header {\n    margin-bottom: 0.5rem;\n  }\n\n  .equity-header h2 {\n    font-size: 1.25rem;\n    text-align: center;\n    margin: 0.5rem 0;\n  }\n\n  .equity-controls {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: center;\n    padding: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .equity-table-controls {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: center;\n    margin-bottom: 0.5rem;\n    padding: 0;\n  }\n\n  /* Simplify equity table on mobile - only show Date, Total, Difference */\n  /* Hide: Cash, Stocks, Options, Stocks Diff, Options Diff */\n  .equity-table th:nth-child(2),\n  .equity-table td:nth-child(2),\n  .equity-table th:nth-child(3),\n  .equity-table td:nth-child(3),\n  .equity-table th:nth-child(4),\n  .equity-table td:nth-child(4),\n  .equity-table th:nth-child(5),\n  .equity-table td:nth-child(5),\n  .equity-table th:nth-child(6),\n  .equity-table td:nth-child(6) {\n    display: none !important;\n  }\n\n  .equity-table-container {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    overflow: visible;\n  }\n\n  .equity-table {\n    font-size: 0.75rem;\n    width: 100%;\n    margin: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n  }\n\n  .equity-table th,\n  .equity-table td {\n    padding: 4px 2px;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  /* Date column - 30% width */\n  .equity-table th:first-child,\n  .equity-table td:first-child {\n    text-align: left;\n    width: 30%;\n    padding-left: 4px;\n  }\n\n  /* Total column - 35% width */\n  .equity-table th:nth-child(7),\n  .equity-table td:nth-child(7) {\n    text-align: center;\n    width: 35%;\n  }\n\n  /* Difference column - 35% width */\n  .equity-table th:last-child,\n  .equity-table td:last-child {\n    text-align: right;\n    width: 35%;\n    padding-right: 4px;\n  }\n\n  /* Remove extra spacing */\n  .equity-table thead th {\n    padding: 6px 2px;\n    font-size: 0.7rem;\n  }\n\n  .equity-table tbody td {\n    padding: 4px 2px;\n    font-size: 0.75rem;\n  }\n\n  /* Goals Display */\n  .goals-display-widget {\n    padding: 1rem;\n  }\n\n  .goals-header h3 {\n    font-size: 1.25rem;\n    text-align: center;\n  }\n\n  .goals-cards {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .goal-card {\n    max-width: 100%;\n    min-width: 100%;\n    margin: 0 auto;\n  }\n\n  .year-equity-overview {\n    flex-direction: column;\n    gap: 10px;\n    padding: 15px;\n    text-align: center;\n  }\n\n  .equity-arrow {\n    transform: rotate(90deg);\n  }\n\n  .year-progress-info {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  /* Hide year chart on mobile for simplicity */\n  .year-progress-chart {\n    display: none;\n  }\n\n  /* Open Positions - Only override for mobile, keep Equity styling for desktop */\n  .open-positions-header h2 {\n    font-size: 1.5rem;\n    text-align: center;\n  }\n\n  .open-positions-header {\n    text-align: center;\n  }\n\n  /* Hide description column on mobile - using class selector */\n  .description-cell {\n    display: none !important;\n  }\n\n  /* Hide description header - target th that contains \"Description\" text */\n  .open-positions-table th.sortable-header {\n    position: relative;\n  }\n\n  /* Hide description header by targeting the specific column */\n  /* Note: This assumes description is after Symbol column - adjust if needed */\n  .open-positions-table thead tr th:nth-child(3),\n  .open-positions-table tbody tr td:nth-child(3) {\n    display: none !important;\n  }\n\n  /* Trades table */\n  .trades-table {\n    font-size: 0.8rem;\n  }\n\n  .trades-table th,\n  .trades-table td {\n    padding: 6px 4px;\n  }\n\n  /* PMCC - Show only conclusions/summary */\n  .pmcc-list-item {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .pmcc-detail-section {\n    margin-bottom: 1rem;\n  }\n\n  /* Hide detailed PMCC tables on mobile, show only summary */\n  .leaps-details-table,\n  .covered-calls-details-table {\n    display: none;\n  }\n\n  .summary-stats {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .summary-stat {\n    padding: 0.75rem;\n    background: #f8f9fa;\n    border-radius: 4px;\n  }\n\n  /* Tables - make scrollable */\n  .equity-table-container,\n  .open-positions-table-container,\n  .trades-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Home page */\n  .home-stats {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .stat-card {\n    padding: 1rem;\n    text-align: center;\n  }\n\n  /* Hide complex charts and graphs on mobile */\n  .home-charts,\n  .home-graphs {\n    display: none;\n  }\n\n  /* Login page */\n  .login-container {\n    padding: 1rem;\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .login-form {\n    padding: 1.5rem;\n    width: 100%;\n    max-width: 100%;\n  }\n\n  /* Trades - simplify on mobile */\n  .trades-header h2 {\n    font-size: 1.5rem;\n    text-align: center;\n  }\n\n  .trades-controls {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n  }\n\n  /* Hide complex trade views on mobile */\n  .trades-pnl-view,\n  .trades-grouped-view {\n    display: none;\n  }\n\n  /* Make all tables horizontally scrollable */\n  table {\n    min-width: 600px;\n  }\n\n  .table-container,\n  .equity-table-container,\n  .open-positions-table-container,\n  .trades-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 100%;\n  }\n\n  /* Goals history table */\n  .goals-history-table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  /* Responsive text sizes */\n  h1, h2, h3, h4 {\n    word-wrap: break-word;\n  }\n\n  /* Better spacing for mobile */\n  .App-main > * {\n    margin-bottom: 1rem;\n  }\n}\n\n  /* Very small screens (phones in portrait) */\n@media (max-width: 480px) {\n  .App-header {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .header-left h1 {\n    font-size: 1rem;\n  }\n\n  .equity-header h2,\n  .open-positions-header h2 {\n    font-size: 1.1rem;\n    margin: 0.25rem 0;\n  }\n\n  .equity-container {\n    padding: 0.15rem;\n  }\n\n  .equity-table {\n    font-size: 0.7rem;\n  }\n\n  .equity-table th,\n  .equity-table td {\n    padding: 3px 1px;\n  }\n\n  .equity-table thead th {\n    padding: 5px 1px;\n    font-size: 0.65rem;\n  }\n\n  .equity-table tbody td {\n    padding: 3px 1px;\n    font-size: 0.7rem;\n  }\n\n  .trades-table {\n    font-size: 0.75rem;\n  }\n\n  .trades-table th,\n  .trades-table td {\n    padding: 4px 2px;\n  }\n\n  .goal-card {\n    padding: 8px;\n  }\n\n  .year-progress-chart {\n    margin-top: 20px;\n  }\n\n  .year-progress-chart h4 {\n    font-size: 1rem;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
